import { Header, Modal } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { BudgetCategoryImporter } from './BudgetCategoryImporter'
import messages from './messages'

export interface BudgetCategoryImporterModalProps {
  open?: boolean
  onDismiss?(): void
}

export const BudgetCategoryImporterModal = ({
  open = false,
  onDismiss = () => undefined,
}: BudgetCategoryImporterModalProps) => {
  const intl = useProcurifyIntl()

  return (
    <Modal
      maxWidth='md'
      open={open}
      onClose={onDismiss}
      aria-labelledby='budget-category-import-modal-title'
    >
      <Modal.Card>
        <Modal.Header onClose={onDismiss}>
          <Header as='h5' id='budget-category-import-modal-title'>
            {intl.formatMessage(messages.budgetsImporterModalTitle)}
          </Header>
        </Modal.Header>
        <Modal.Content>
          <BudgetCategoryImporter handleModalClose={onDismiss} />
        </Modal.Content>
      </Modal.Card>
    </Modal>
  )
}
